<template>
    <div>
        <section class="xlrclh">
            <img class="top-img" src="./../assets/imgs/130/bg-tit.png" alt="" />
            <div class="technological-process">
                <div class="zcjj">
                    <img class="top" style="height: 1.12rem" src="./../assets/imgs/xllh/rcgyysq_zcjj.png" alt="" />
                    <div class="content">
                        <div class="des">
                            <div style="
                                          font-size: 0.34rem;
                                          font-weight: bold;
                                          margin-bottom: 0.22rem;
                                      ">
                            </div>
                            为深入实施人才强市战略，助力全国创新人才高地建设，着力营造无后顾之忧的创新创业就业环境，结合成都实际，制定出台《成都市进一步加强人才安居的若干政策措施》，满足人才多元化购房。
                        </div>
                    </div>
                </div>
                <div class="contact">
                    <img class="top" src="./../assets/imgs/xllh/rcgysq_sqdx.png" alt="" />
                    <div class="content" style="font-weight: 500; font-size: 0.26rem;">
                        符合《成都市人才分类目录》的人才。
                    </div>
                </div>
                <div class="contact">
                    <img class="top" src="./../assets/imgs/130/zcnr.png" alt="" />
                    <div class="content" style="font-weight: 500; font-size: 0.26rem;">
                        《成都市人才分类目录》中的A、B、C、D、E、F类人才在蓉工作并取得人才安居资格后，可不受户籍、社保缴纳时间限制在我市购买商品住房或二手住房。其中，A、B、C、D、E类人才购房还可不受住房限购区域限制。
                    </div>
                </div>
                <div class="contact">
                    <img class="top" src="./../assets/imgs/xllh/rpjh-sqlc-t.png" alt="" />
                    <div class="content" style="font-weight: 500; font-size: 0.26rem;">
                        人才可自行登录“成都人才安居服务网”进行申请。
                    </div>
                </div>
                <!-- <div class="contact">
                    <img class="top" src="./../assets/imgs/xllh/rclh-more.png" alt="" />
                    <div class="content">
                        全年
                    </div>
                </div> -->
                <div class="contact">
                    <img class="top" src="./../assets/imgs/130/dwdh.png" alt="" />
                    <div class="content">
                        <div class="number">
                            <span class="label">政策咨询电话：</span>
                            <div>
                                <a href="tel:028-61889280">028-61889280</a>
                            </div>
                        </div>
                        <div class="unit">
                            <span class="label">责任单位：</span>
                            成都市住房和城乡建设局住房保障处
                        </div>
                    </div>
                </div>
                <div class="sqsj" style="display: flex;
                justify-content: space-between;">
                    <img style="width: 1.94rem;height: 1.94rem;" src="./../assets/imgs/130/qr-code-left.png" alt="" />
                    <img style="width: 4.14rem;height:1.34rem" src="./../assets/imgs/130/qr-code.png" alt="" />
                    <!-- <div class="rcrclc-zhfwpt">
                        <img src="./../assets/imgs/xllh/rcrclc_zhfwpt_code.png" alt="" />
                    </div> -->
                </div>
            </div>
        </section>
    </div>
</template>

<script>
export default {
    data() {
        return {};
    },


    mounted() { },

    methods: {},
};
</script>
<style lang="scss" scoped>
@import "@/assets/public.scss";

.sqsj {
    width: 6.85rem;
    background: #ffffff;
    border-radius: 0.26rem 0.26rem 0.26rem 0.26rem;
    margin: 0.3rem auto 0;
    box-sizing: border-box;
    text-align: left;
    padding: 0.3rem;
    padding-bottom: 0.15rem;

    .rcrclc-sqsj {
        width: 5.58rem;
        height: 1.94rem;
        margin-top: 0.3rem;
        background-image: url("./../assets/imgs/xllh/rcrclc_sqsj.png");
        background-size: 100% 100%;
        background-repeat: no-repeat;
        margin: 0 auto;

        img {
            width: 1.94rem;
            height: 1.94rem;
        }
    }

    .rcrclc-zhfwpt {
        width: 5.58rem;
        height: 1.94rem;
        margin-top: 0.3rem;
        background-image: url("./../assets/imgs/xllh/rcrclc_zhfwpt.png");
        background-size: 100% 100%;
        background-repeat: no-repeat;
        margin: 0.3rem auto 0;

        img {
            width: 1.94rem;
            height: 1.94rem;
        }
    }
}

.xlrclh {
    background-color: $base-back;
    min-height: 100vh;

    // padding-bottom: 3.7rem;
    .top-img {
        width: 7.47rem;
        height: 5.6rem;
    }

    .technological-process {
        transform: translateY(-1.9rem);

        .zcjj {
            .top {
                width: 6.68rem;
                height: 2.12rem;
            }

            .content {
                width: 6.68rem;
                background: #ffffff;
                margin: -0.45rem auto 0;
                padding: 0.1rem 0.33rem 0.64rem 0.36rem;
                box-sizing: border-box;
                border-radius: 0rem 0rem 0.26rem 0.26rem;
                line-height: 0.44rem;


                .title {
                    font-size: 0.34rem;
                    font-weight: bold;
                    color: #333333;
                    text-align: left;
                    line-height: 0.5rem;
                }

                .des {
                    font-size: 0.26rem;
                    font-weight: 500;
                    color: #4e4e4e;
                    line-height: 0.44rem;
                    text-align: left;
                    margin-top: 0.16rem;
                }
            }
        }

        .rhtj {
            position: relative;

            .top {
                width: 7.03rem;
                height: 1.37rem;
                margin-left: -0.18rem;
            }

            .content {
                width: 6.85rem;
                background: #e8eeff;
                margin: -0.45rem auto 0;
                padding: 0 0.33rem 0.64rem 0.36rem;
                box-sizing: border-box;
                border-radius: 0rem 0rem 0.26rem 0.26rem;

                .title {
                    font-size: 0.36rem;
                    font-weight: bold;
                    color: #333333;
                    text-align: left;
                    line-height: 0.5rem;
                }

                .des {
                    font-size: 0.26rem;
                    color: #4e4e4e;
                    background: #ffffff;
                    border-radius: 0.2rem 0.2rem 0.2rem 0.2rem;
                    padding: 0.3rem 0.23rem 0.3rem;
                    text-align: left;
                    line-height: 0.44rem;
                    position: relative;

                    .cdcslt {
                        width: 6.03rem;
                        height: 1.94rem;
                    }

                    .describe {
                        background: linear-gradient(180deg,
                                #ffffff 0%,
                                rgba(255, 255, 255, 0) 100%);
                        border-radius: 0.2rem 0.2rem 0.2rem 0.2rem;
                        opacity: 1;
                        padding: 0.33rem 0.33rem 0 0.15rem;

                        .num {
                            min-width: 0.39rem;
                            height: 0.39rem;
                            background: #739bfe;
                            color: #ffffff;
                            display: inline-flex;
                            border-radius: 50%;
                            justify-content: center;
                            align-items: center;
                            margin-right: 0.14rem;
                        }
                    }
                }
            }
        }

        .gmlc {
            position: relative;
            margin-top: 0.22rem;

            .top {
                width: 7.03rem;
                height: 1.37rem;
                margin-left: -0.18rem;
            }

            .content {
                width: 6.85rem;
                background: #e8eeff;
                margin: -0.45rem auto 0;
                padding: 0.33rem;
                box-sizing: border-box;
                border-radius: 0rem 0rem 0.26rem 0.26rem;

                .title {
                    font-size: 0.3rem;
                    font-weight: bold;
                    color: #333333;
                    text-align: left;
                    line-height: 0.5rem;
                }

                .des {
                    color: #4e4e4e;
                    text-align: left;
                    background: #ffffff;
                    border-radius: 0.2rem 0.2rem 0.2rem 0.2rem;
                    padding: 0.3rem 0.23rem;
                    font-size: 0.26rem;
                    color: #4e4e4e;

                    position: relative;
                    line-height: 0.44rem;
                    margin-top: 0.8rem;

                    .title {
                        position: absolute;
                        top: -0.5rem;
                        left: 50%;
                        transform: translateX(-50%);
                        width: 4.5rem;
                        height: 0.67rem;
                        line-height: 0.67rem;
                        display: flex;
                        justify-content: center;
                        align-content: center;
                        font-size: 0.32rem;
                        font-weight: bold;
                        color: #ffffff;
                        border-radius: 1rem;
                        background-color: #739bfe;
                    }

                    .line-item {
                        font-size: 0.26rem;
                        position: relative;
                        z-index: 3;

                        .line {
                            position: absolute;
                            width: 0.02rem;
                            height: 100%;
                            border-left: 0.02rem dashed #739bfe;
                            left: 0.2rem;
                            z-index: 0;
                            //   background-color: #739bfe;
                        }

                        .line-title {
                            font-size: 0.3rem;
                            font-weight: bold;
                            color: #3d5aa3;
                            line-height: 0.46rem;
                        }

                        .line-top {
                            display: flex;

                            .line-num {
                                min-width: 0.39rem;
                                height: 0.39rem;
                                line-height: 0.39rem;
                                background: #739bfe;
                                color: #ffffff;
                                display: inline-flex;
                                border-radius: 50%;
                                justify-content: center;
                                align-items: center;
                                align-content: center;
                                margin-right: 0.14rem;
                                position: relative;
                                z-index: 3;
                            }
                        }

                        .line-content {
                            //   border-left: 0.02rem dashed #739bfe;
                            padding-bottom: 0.32rem;
                            margin-left: 0.2rem;
                            padding-left: 0.32rem;
                            padding-top: 0.15rem;
                            word-break: break-all;
                            line-height: 0.44rem;
                        }
                    }

                    .des-item {
                        font-size: 0.26rem;
                        color: #4e4e4e;
                        padding-left: 0.33rem;
                        padding-top: 0.22rem;
                        margin-left: 0.2rem;
                        border-left: 0.02rem dashed #739bfe;
                        padding-bottom: 0.55rem;

                        .cdrcwewm {
                            width: 5.51rem;
                            height: 1.43rem;
                            margin-top: 0.16rem;
                        }
                    }

                    .describe-item {
                        font-size: 0.26rem;
                        color: #4e4e4e;
                        padding-left: 0.33rem;
                        padding-top: 0.22rem;
                        margin-left: 0.2rem;
                        word-break: break-all;
                    }
                }
            }
        }

        .gmlc2 {
            position: relative;
            margin-top: 0.22rem;

            .top {
                width: 7.03rem;
                height: 1.37rem;
                margin-left: -0.18rem;
            }

            .content {
                width: 6.85rem;
                background: #fff;
                margin: -0.45rem auto 0;
                padding: 0.33rem;
                box-sizing: border-box;
                font-size: 0.26rem;
                color: #4e4e4e;
                line-height: 0.44rem;

                text-align: left;
                border-radius: 0rem 0rem 0.26rem 0.26rem;
            }
        }
    }
}
</style>
